import { http } from '@/api/http'
import type { ApiRegion, ApiRestaurant } from '@/api/types/location'

/** Регионы и рестораны — справочники, на которых стоит вся привязка к точке. */
export const locationService = {
  regions: () => http.get<ApiRegion[]>('/regions/List'),
  restaurants: () => http.get<ApiRestaurant[]>('/restaurants/List'),
}

/*
 * Адреса по координатам сюда не ходят: их считает Яндекс на клиенте
 * (`utils/yandexSearch`). Эндпоинт `/tg/address/Get` был вторым источником
 * и отдавал строку на узбекском независимо от языка приложения.
 */
